import { Option } from "~/common/utils";
import { ZoomSessionType } from "~/providers/utils/types/zoomMeetingTypes";

export const ZOOM_SESSION_TYPE_LABELS: Record<ZoomSessionType, string> = {
  INTAKE: "Intake",
  FOLLOW_UP: "Follow-up",
  CARE_GUIDE: "Care Guide",
};

export const ZOOM_SESSION_TYPE_OPTIONS: Option[] = [
  { label: "-", value: "" },
  ...Object.entries(ZOOM_SESSION_TYPE_LABELS).map(([value, label]) => ({
    label,
    value,
  })),
];

export const ZOOM_SESSION_HEADER_TYPE_OPTIONS: Option[] = [
  { label: "Select type", value: "" },
  ...Object.entries(ZOOM_SESSION_TYPE_LABELS).map(([value, label]) => ({
    label,
    value,
  })),
];
